module.exports = __webpack_public_path__ + "img/40_380_85_800.a7c2b238.jpg";